import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/article/page";
import SafetyGuide from "../pages/articles/SafetyGuide";
import BestSpreadsheet from "../pages/articles/BestSpreadsheet";
import VsPandabuy from "../pages/articles/VsPandabuy";
import ShoesGuide from "../pages/articles/ShoesGuide";
import HoodiesGuide from "../pages/articles/HoodiesGuide";
import AccessoriesGuide from "../pages/articles/AccessoriesGuide";
import BuyingTips from "../pages/articles/BuyingTips";
import HowToUse from "../pages/articles/HowToUse";
import UpdateNews from "../pages/articles/UpdateNews";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/acbuy-spreadsheet-guide", element: <ArticleGuide /> },
  { path: "/acbuy-spreadsheet-safe-guide", element: <SafetyGuide /> },
  { path: "/best-acbuy-spreadsheet-2026", element: <BestSpreadsheet /> },
  { path: "/acbuy-spreadsheet-vs-pandabuy", element: <VsPandabuy /> },
  { path: "/acbuy-spreadsheet-shoes-guide", element: <ShoesGuide /> },
  { path: "/acbuy-spreadsheet-hoodies-guide", element: <HoodiesGuide /> },
  { path: "/acbuy-spreadsheet-accessories-guide", element: <AccessoriesGuide /> },
  { path: "/acbuy-spreadsheet-buying-tips", element: <BuyingTips /> },
  { path: "/acbuy-spreadsheet-how-to-use", element: <HowToUse /> },
  { path: "/acbuy-spreadsheet-update-news", element: <UpdateNews /> },
  { path: "*", element: <NotFound /> },
];

export default routes;